import { Navigate } from "react-router-dom";

/** Legacy `/dashboard/connect` — replaced by /dashboard/manifest (Manifest module
 *  fully supersedes the earlier /connect page with proper privacy filtering).
 *  Kept as a soft redirect so any old bookmarks continue to work.
 */
export default function Connect() {
  return <Navigate to="/dashboard/manifest" replace />;
}
